export default {
    title: 'Erhebungszeiträume',

    start_date: 'Startdatum',
    end_date: 'Enddatum',
    recording_start_date: 'Erfassungsstart',
    recording_end_date: 'Erfassungsende',
}